<template>
  <view class="warp" wx:style="{{warpStyle}}">
    <block wx:if="{{!error}}">
      <text class="rule" wx:style="{{ruleStyle}}" bindtap="gotoLink(pageConfig.rule.link)">规则</text>
      <red-packet-open
        wx:if="{{hasGetCoupon && hasCoupon && couponList}}"
        template="{{info.template}}"
        btnText="{{btnText}}"
        couponInfo="{{activityCouponList || []}}"
        couponList="{{couponList}}"
        bind:couponClick="couponPopShow"
        bind:click="toUseCoupon"
        bind:goToLink="couponToUse"
      />
      <red-packet-close
        wx:elif="{{activityCouponList || pageConfig}}"
        couponInfo="{{activityCouponList || []}}"
        config="{{pageConfig.redPacket}}"
        template="{{info.template}}"
        btnText="{{btnText}}"
        bind:click="getCouponCz"
      />
      <scroll-text
        wx:if="{{textRoll}}"
        text="{{textRoll}}"
      />
      <!-- 转化区 -->
      <cz-banner wx:if="{{pageConfig.conversion.isShow}}" template="{{info.template}}" params="{{pageConfig.conversion}}"/>
      <gas-station-list
        wx:if="{{stationParams && showGasModule}}"
        showTabOrder="{{pageConfig.showTabOrder || 'gasFirst'}}"
        class="container-station"
        params={{stationParams}}
        bind:stationShow="stationShow"
        bind:changeTab="changeTab"
        bind:footerBtnClick="toMoreStation"
        bind:toGuide="dhNearby"
        bind:goCarWahDetail="goCarWahDetail"
      />
      <image-list imageList="{{pageConfig.imageList}}" />
      <res-banner wx:if="{{activityCouponList}}" template="{{info.template}}" />
    </block>
    <error-view wx:else message="{{errmsg}}" />
    <popup-result
      wx:if="{{popupResult}}"
      template="{{info.template}}"
      popupData="{{popupResult}}"
      pageConfig="{{pageConfig}}"
      bind:close="popupClose"
      bind:click="popupClick"
    />
  </view>
</template>

<script>
import mpx, { createComponent } from '@mpxjs/core'
import { props as properties } from './model/props'
import { trackEvent, utils, sendXspmScan, build } from '@didi/webx-js'
import { preloadImage, chapter, initLogin, getEnvParams } from '../../lib/utils'
import couponMixin from '../../lib/mixin/coupon-v3'
import store from '../../lib/store'
import { getStyle } from '../../lib/editor/utils.js'
import api from '../../lib/service'
preloadImage([ 'https://ut-static.udache.com/webx/ut/RMt7MK-61M2AoRA8h3RdU.png', 'https://ut-static.udache.com/webx/ut/3LwakHd_uV5uQ-dCT17rW.png', 'https://ut-static.udache.com/webx/ut/gAzyB7pdFAfGQ7MSOBz-2.png' ], 1000)

createComponent({
  properties,
  mixins: [ couponMixin ],
  data: {
    showGasModule: true,
  },
  computed: {
    ...store.mapGetters([ 'cityInfo', 'initData' ]),
    activityCouponList() {
      return this.initData.activity_info?.rewards
    },
    textRoll() {
      return this.pageConfig.textRoll.text
    },
    warpStyle() {
      return getStyle(this.pageConfig.index.style)
    },
    stationParams() {
      // return {
      //   token: '0EMXQw9BRJn4a0Wr5SMolUzr415nkY5I3i5KTJyWvRsczDluw0AQBdG7VNwgfs8-nTr3HbzQSzIGLCgidHeBjKvwDpYI8qZNGMsJN1YiXJKMlQnvdSYfXVWtnrkQ3kYZpZXrqQQvrxhvBBjvRJpTrXvLvXnWMD6JYuzEwe3v_v-xE3oYXyfVu7ou6ptAkjfNlFLB-CFwjN_zfwYAAP__',
      //   scene: 1101,
      //   lng: 116.4133837,
      //   lat: 39.91092455,
      // }
      if (
        this.pageConfig.index.showStation &&
        this.userInfo.token &&
        this.cityInfo.lat &&
        this.cityInfo.lng
      ){
        return {
          token: this.userInfo.token,
          scene: 1101,
          ...this.cityInfo,
        }
      }
      else {
        return false
      }
    },
  },
  methods: {
    toMoreStation({ detail }) {
      trackEvent('userteam_fx_home_more_ck', '“查看更多加油站/洗车店”按钮', { tab_txt: detail.title })
      const link = detail.tab === 'gas' ? 'https://v.didi.cn/n7ojnaL' : 'https://v.didi.cn/Px6jG0x'
      this.gotoLink(link)
    },
    // 加油导航
    dhNearby({ detail }) {
      trackEvent('userteam_fx_home_dhnearby_ck', '领券页面-附近tab-导航-点击', { tab_txt: detail.title })
    },
    stationShow({ detail }) {
      trackEvent('userteam_fx_home_nearbytab_sw', '领券页面-附近tab-展现', { bt_txt: detail.title })
    },
    changeTab({ detail }) {
      trackEvent('userteam_fx_home_nearbytab_sw', '领券页面-附近tab-展现', { bt_txt: detail.title })
      trackEvent('userteam_fx_home_nearbytab_ck', '领券页面-附近tab-点击', { bt_txt: detail.title })
    },
    // 洗车跳购买
    goCarWahDetail({ detail }) {
      trackEvent('userteam_fx_home_dhnearby_ck', '领券页面-附近tab-导航-点击', { tab_txt: detail.title })
      const carWashLink = build('https://v.didi.cn/Px6jG0x', { physicId: detail.item.physic_id }, true)
      console.log('carWashLink', carWashLink)
      this.gotoLink(carWashLink)
    },
    getCouponCz: utils.debounce(
      async function(e, showLoading = true) {
        showLoading &&
          trackEvent('userteam_ddlm_coupon_bt_ck', '领券页面-按钮-点击')
        if (this.doingGetCoupon) return
        this.doingGetCoupon = true
        await initLogin({
          needLogin: true,
          redirectParams: {
            is_back: '1',
          },
        }).catch(e => {
          this.doingGetCoupon = false
          throw e
        })
        trackEvent('userteam_fx_home_bt_ck', '立即领取', {
          bt_text: this.btnText,
          action: 'ljlq',
        })
        showLoading &&
          mpx.showLoading({
            mask: true,
          })
        const envInfo = await getEnvParams(e)
        const res = await api.getCoupon({
          env: envInfo,
          req_env: this.curEnv,
          dunion_callback: this.query.dunion_callback || '',
        })
        this.doingGetCoupon = false
        mpx.hideLoading()
        if (res.errno !== 0) {
          mpx.showToast({
            title: res.errmsg,
            icon: 'none',
            mask: true,
          })
        } else {
          this.showGasModule = false
          this.$nextTick(() => {
            this.showGasModule = true
          })
          this.popupShow(res.data)
        }
        await this.getRewardList()
        this.hasGetCoupon = true
        sendXspmScan(
          {},
          {
            a: '',
            b: this.info.template,
            c: chapter[this.info.template].toUseBtn,
            d: '',
          }
        )
        sendXspmScan(
          {},
          {
            a: '',
            b: this.info.template,
            c: chapter[this.info.template].couponToUseBtn,
            d: '',
          }
        )
      },
      800,
      true
    ),
    // 点击券面展示弹窗
    couponPopShow({ detail }) {
      console.log('couponPopShow', detail)
      this.popupShow({
        rewards: detail?.couponThisList,
        coupon_txt: detail.coupon_txt.replace(' >', ''),
        coupon_link: detail.coupon_link,
      })
    },
  },
})
</script>
<style lang="stylus" >
.mpx-button
    padding 0
    &::after
      display none
</style>

<style lang="stylus" scoped>
  @font-face {
    font-family: DIN-Bold-self;
    src: url(https://dpubstatic.udache.com/static/dpubimg/5e78fa44-928b-4132-aa31-d5bac7b67ece.ttf);
  }
  .warp
    min-height 100vh
    padding-bottom 180rpx
    font-size: 0;
    overflow hidden
    box-sizing: border-box;
    line-height: normal;
    background-size: 100% auto
    background-repeat: no-repeat;
    .rule
      position absolute
      right 0
      border-radius: 100rpx 0 0 100rpx;
      font-family: PingFangSC-Semibold;
      font-size: 24rpx;
      letter-spacing: 1rpx;
      font-weight: bold
      padding 4rpx 16rpx 4rpx 25rpx
    .header-image
      width: 750rpx
    .container-station
      margin 40rpx 25rpx 0
      display: block
</style>
<script type="application/json">
{
  "component": true,
  "usingComponents": {
    "red-packet-close": "../../components/cz/red-packet-close.mpx",
    "red-packet-open": "../../components/cz/red-packet-open-cz.mpx",
    "error-view": "../../components/common/error-view.mpx?async=error-view",
    "popup-result": "../../components/cz/popup-result.mpx",
    "gas-station-list": "@didi/ut-components/packages/gas-station-list/components/index.mpx",
    "image-list": "../../components/common/image-list.mpx",
    "res-banner": "../../components/common/res-banner.mpx",
    "scroll-text": "../../components/common/scroll-text.mpx",
    "cz-banner": "../../components/cz/cz-banner.mpx"
  }
}
</script>
